import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useGlobalStudiesCache } from "@/hooks/useGlobalStudiesCache";
import { Pause } from "lucide-react";

export function SystemPausedBanner() {
  const { data } = useGlobalStudiesCache();

  if (!data?.all_frozen) return null;

  return (
    <Alert className="border-amber-500/30 bg-amber-500/10">
      <Pause className="h-4 w-4 text-amber-400" />
      <AlertTitle className="text-amber-400">System Update in Progress</AlertTitle>
      <AlertDescription className="text-amber-300/80">
        Optimization processing is temporarily paused for a system update. Your
        queued studies will resume shortly.
      </AlertDescription>
    </Alert>
  );
}
